// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:08:42

export default {
  "id": "army-fight-3d",
  "slug": "army-fight-3d",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/c360b3d8953441208dfe90b3e6976c09-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/c360b3d8953441208dfe90b3e6976c09/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Army Fight 3d",
      "description": "Begin the nervous army battles in Army Fight 3D. Here you need strategic thinking and quick reflexes.In this fun action battle game, you aim to build a powerful army. Defend your base, and defeat the enemy. Start by creating and upgrading your army.",
      "instructions": "Mouse click or tap to play\n",
      "genres": [
        "Battle"
      ],
      "tags": [
        "army",
        "defence",
        "stickman"
      ]
    },
    "zh-CN": {
      "title": "军斗3D",
      "description": "开始紧张刺激的军队战斗之旅，在《军队战斗3D》中。这里你需要战略思考和快速反应。在这款有趣的动作战斗游戏中，你的目标是建立一支强大的军队。捍卫你的基地，击败敌人。首先，创建并升级你的军队。",
      "instructions": "鼠标点击或轻触开始游戏",
      "genres": [
        "战斗"
      ],
      "tags": [
        "军队",
        "防御",
        "小人物"
      ]
    },
    "zh-TW": {
      "title": "陸戰3D",
      "description": "開始在《軍團戰爭3D》中的緊張軍隊戰爭。在這裡，你需要策略思考與敏捷反應。在這款有趣動作戰鬥遊戲中，你的目標是建立一個強大的軍隊。守護你的基地，擊敗敵人。從創建和升級你的軍隊開始。",
      "instructions": "滑鼠點擊或輕觸開始遊戲",
      "genres": [
        "戰鬥"
      ],
      "tags": [
        "軍隊",
        "防衛",
        "小丑人"
      ]
    },
    "zh-HK": {
      "title": "軍團戰3D",
      "description": "開始在《軍隊戰鬥3D》中的緊張軍隊戰鬥。在此，你需要策略思考及敏捷反應。在這款有趣的動作戰鬥遊戲中，你的目標是建立一支強大的軍隊。守護你的基地，擊敗敵人。從創建和升級你的軍隊開始。",
      "instructions": "用滑鼠點擊或觸控遊玩",
      "genres": [
        "戰鬥"
      ],
      "tags": [
        "軍隊",
        "防衛",
        "stickman"
      ]
    },
    "ja": {
      "title": "アーミーファイト3D",
      "description": "軍隊戦闘の緊張感に満ちたArmy Fight 3Dを始めましょう。ここでは戦略的な思考と素早い反応が必要です。この楽しいアクションバトルゲームで、強力な軍隊を築くことを目指します。基地を守り、敵を撃退しましょう。まずは軍隊を創造し、アップグレードします。",
      "instructions": "マウスクリックまたはタップして遊ぶ",
      "genres": [
        "バトル"
      ],
      "tags": [
        "軍隊",
        "防衛",
        "スティックマン"
      ]
    },
    "ko": {
      "title": "아르미 파이트 3D",
      "description": "3D 애니메이션 군대전투에서 긴장감 넘치는 군대전투를 시작하세요. 여기서 전략적 사고와 빠른 반응이 필요합니다. 이 흥미로운 액션전투 게임에서는 강력한 군대를 건설하는 것이 목표입니다. 귀하의 기지를 방어하고 적을 물리치세요. 처음으로 군대를 만들고 업그레이드하세요.",
      "instructions": "마우스 클릭이나 탭하여 게임 시작",
      "genres": [
        "전투"
      ],
      "tags": [
        "군대",
        "방어",
        "스틱맨"
      ]
    },
    "fr": {
      "title": "Bataille d'Armée 3D",
      "description": "Commencez les batailles d'armée nerveuses dans Army Fight 3D. Ici, vous avez besoin de pensée stratégique et de réflexes rapides. Dans ce jeu d'action amusant, votre objectif est de construire une armée puissante. Défendez votre base et battez l'ennemi. Commencez par créer et améliorer votre armée.",
      "instructions": "Clic ou appui sur l'écran pour jouer",
      "genres": [
        "Bataille"
      ],
      "tags": [
        "armée",
        "défense",
        "stickman"
      ]
    }
  }
};
